import React from 'react';
import { Tabs, Box } from '@chakra-ui/react';
import { useColorModeValue } from '../../ui/color-mode';
import { darkMode, lightMode } from '../../../theme/config';

const FitTabs = (props) => {
  const textColor = useColorModeValue(lightMode.textColor, darkMode.textColor);
  const dividerColor = useColorModeValue(lightMode.containerBorderColor, darkMode.containerBorderColor);
  const {
    variant = 'enclosed',
    width = '100%',
    fitted = true,
    value,
    onChange,
    tabs = [],
    tabListToPageEnd = false,
  } = props;

  return (
    <Box position="relative" w={width}>
      <Tabs.Root
        variant={variant}
        fitted={fitted}
        value={value}
        onValueChange={onChange}
      >
        <Tabs.List
          gap={0}
          position={tabListToPageEnd ? 'absolute' : 'relative'}
          right={tabListToPageEnd ? 0 : 'auto'}
          top={tabListToPageEnd ? -10 : 'auto'}
          zIndex={1}
        >
          {tabs.map((tab, index) => (
            <React.Fragment key={index}>
              <Tabs.Trigger
                value={tab.value}
                color={textColor}
                _selected={{
                  color: 'green.500',
                  borderColor: 'green.500',
                }}
                px={4}
                position="relative"
                fontWeight="semibold"
              >
                {tab.label}
              </Tabs.Trigger>
              {index < tabs.length - 1 && (
                <Box
                  as="span"
                  position="relative"
                  _before={{
                    content: '""',
                    position: 'absolute',
                    left: '0',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '60%',
                    width: '1px',
                    bg: dividerColor,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Tabs.List>

        {tabs.some((tab) => tab.panel) && (
          <Tabs.ContentGroup mt={tabListToPageEnd ? 10 : 4}>
            {tabs.map(
              (tab, index) =>
                tab.panel && (
                  <Tabs.Content key={index} value={tab.value}>
                    {tab.panel}
                  </Tabs.Content>
                )
            )}
          </Tabs.ContentGroup>
        )}
      </Tabs.Root>
    </Box>
  );
};

export default FitTabs;
